import { HttpParams } from '@angular/common/http';

/**
 * Converts a typed query-parameter object into Angular HttpParams.
 * - null/undefined values are skipped.
 * - Array values are appended (one entry per element).
 * - All other values are set as strings.
 */
export function buildHttpParams<T extends Record<string, unknown>>(
  params: T,
): HttpParams {
  let httpParams = new HttpParams();
  if (!params || Object.keys(params).length === 0) {
    return httpParams;
  }

  for (const [key, value] of Object.entries(params)) {
    if (value == null) continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        httpParams = httpParams.append(key, `${item}`);
      }
    } else {
      httpParams = httpParams.set(key, `${value}`);
    }
  }

  return httpParams;
}
